<ul>
    <li>
        <div class="selected">
            <a>Home</a>
        </div>
    </li>
    <li>
        <div>
            <a>Dashboard</a>
        </div>
    </li>
</ul>